module.exports = __webpack_public_path__ + "assets/img/NPC030.20e1042b.png";